import React, { useState, useRef, useEffect } from 'react';
import { Button, Skeleton } from '@mui/material';
import { useParams } from 'react-router-dom';
import SideMenuBar from '../../../Components/Layouts/SideMenuBar';
import TopMenuBar from '../../../Components/Layouts/TopMenuBar';
import RightSideBar from '../../../Components/Layouts/RightSideBar';
import img3 from '../../../assets/onlinestatus.png';
import '../../../Styles/Reels/ReelsIndex.css';
import './Profilescreen.css';
import { useTranslation } from 'react-i18next';

import { useNavigate } from 'react-router-dom';
import VideoCard from '../../../Components/VideoCard';
import { useCart } from '../../../CartProvider';
import Loader from '../../../Components/Loader/Loader';
import authMiddleware from '../../../Components/authMiddleware';
import logoIcon from '../../../assets/svg/logo.svg';
import axiosUserInstance from '../../../axiosUserInstance';
import BackButton from '../../../Components/BackButton';
import BackIcon from '../../../assets/svg/backIcon';
import EditProfileIcon from '../../../assets/svg/EditProfileIcon';
import CreatePost from '../CreatePostUi/CreatePost';
import DeleteOfferModal from '../../Vendor/DeleteOfferModal';
import { Helmet } from 'react-helmet';
import { CONSTANT, SEO } from '../../../Utils/Constant';

const Profilescreen = () => {
    const { t } = useTranslation();
    const [contentType, setContentType] = useState('posts');
    const navigate = useNavigate();
    const [buttonWidth, setButtonWidth] = useState(window.innerWidth < 601 ? '50%' : '33%');
    const [Saved, setSaved] = useState(null);
    const [savePost, setSavePost] = useState([]);
    const [userPosts, setUserPost] = useState([]);
    const containerRef = useRef(null);
    const [isLoading, setIsLoading] = useState(true);
    const [userData, setUserData] = useState();
    const [followData, setFollowData] = useState();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
    const { toggleFollow, followStatusMap } = useCart();
    const [activeVideoIndex] = useState(null);
    const [activeUnmutedId, setActiveUnmutedId] = useState(null);
    const [profileImagePreview, setProfileImagePreview] = useState();
    const [selectedPost, setSelectedPost] = useState(null);
    const [openEditModal, setOpenEditModal] = useState(false); 
    const [selectedFiles, setSelectedFiles] = useState(null); 
    const {currentLoginUserId} = useCart();
    const {userName} = useParams();
    const videoRefs = useRef([]);
    const observer = useRef(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    // Add these handler functions
    const handleEditPost = (post) => {
        setSelectedPost(post);
        setOpenEditModal(true);
    };

    const handleDeleteClick = (post) => {
        setSelectedPost(post);
        setShowDeleteModal(true);
    };

    const cancelDelete = () => {
        setSelectedPost(null);
        setShowDeleteModal(false);
    };
    
    const handleVideoRef = (ref, index) => {
        if (ref) {
            videoRefs.current[index] = ref;
        }
    };

    const handleGlobalMuteChange = () => {
        // videoRefs.current.forEach((video, i) => {
        //     if (video) {
        //         video.muted = i !== index;
        //     }
        // });
        // setActiveVideoIndex(index);
    };

    useEffect(() => {
        const handleResize = () => {
            setButtonWidth(window.innerWidth < 601 ? '50%' : '33%');
        };
    
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleContentTypeChange = async (type) => {
        setContentType(type);
        
    };

    const handleSavePost = async () => {
        if (!userName) {
            const location = JSON.parse(localStorage.getItem('selectedLocation'));

            const lat = location?.lat;
            const lng = location?.lng;
            try {
                const res = await axiosUserInstance.get(`/post/savedposts/?location=${lat},${lng}`);

                if (res?.statusText === 'OK') {
                    const data = res?.data?.savedPosts?.[0];
                    setSavePost(data?.Saved_Post_Information);
                }
            } catch (error) {
                console.error(
                    error?.response?.data?.error || 'Unable to connect to the server.'
                );
            }
        }
    };

    useEffect(() => {
        handleSavePost();
    }, [savePost?.Saved_flag]);
    
    const handleDashboardNavigate = () =>{
        window.history.back();
    };

    const fetchUserPosts = async () => {
        const location = JSON.parse(localStorage.getItem('selectedLocation'));

        const lat = location?.lat;
        const lng = location?.lng;
        try {
            setIsLoading(true);
            const response = await axiosUserInstance.get(`/customers/user/${userName || currentLoginUserId}?latitude=${lat}&longitude=${lng}`);
            setIsLoading(false);
            const data = response?.data?.posts?.[0];
            setUserPost(data?.Post_Information);
            setUserData(data);
            setFollowData(response?.data);
            setProfileImagePreview(data?.User_Information?.User_Profile_Picture);
        } catch (error) {
            setIsLoading(false);
            console.error('Error fetching user posts:', error);
        }
    };

    useEffect(() => {
        fetchUserPosts();
    }, [userName]);

    const confirmDelete = async () => {
        const payload = {
            Status: 'deactive',
            Updated_by: currentLoginUserId,
        };
        try {
            setIsLoading(true);
            await axiosUserInstance.put(`/posts/post/${selectedPost?.Post_ID}`, payload);
            setIsLoading(false);
            setShowDeleteModal(false);
            setSelectedPost(null);
            // Refresh posts after deletion
            if (contentType === 'posts') {
                fetchUserPosts();
            } else {
                handleSavePost();
            }
        } catch (error) {
            console.error('Error deleting post:', error);
        }
    };

    const handleFollow = async () => {
        if (!authMiddleware()) {  
            return;
        }

        const Data = {
            user_id: userData?.User_Information?.User_ID,
        };
    
        try {
            let res;
            if (followData?.followFlag == 'false') {
                res = await axiosUserInstance.post('/follow/user/userid', Data);
                if (res.status === 201) {
                    toggleFollow(userData?.User_Information?.User_ID, true);
                    setFollowData((prevUserData) => ({
                        ...prevUserData,
                        followFlag: 'true',
                        followCountValue: prevUserData.followCountValue + 1,
                    }));
                }
            } else {
                res = await axiosUserInstance.delete(`/follow/user/userid/${userData?.User_Information?.User_ID}`);
                if (res.status === 200) {
                    toggleFollow(userData?.User_Information?.User_ID, false);
                    setFollowData((prevUserData) => ({
                        ...prevUserData, 
                        followFlag: 'false',
                        followCountValue: prevUserData.followCountValue - 1,
                    }));
                }
            }
        } catch (error) {
            console.error('Error in follow/unfollow action:', error);
        }
    };

    const handleSavedClick = (saved) => {
        setSaved(saved);
    };

    const handleNavigate = () => {
        navigate('/profilesettings');
    };

    const parseAvatarKey = (key) => {
        try {
            const parsedKey = JSON.parse(key); // First parse
            return Array.isArray(parsedKey) ? parsedKey : JSON.parse(parsedKey); // Handle nested parsing
        } catch (error) {
            console.error('Failed to parse Attachment_Keys:', error);
            return [];
        }
    };

    const imageURL = profileImagePreview?.trim() ? profileImagePreview : null;
    const [bgColor, setBgColor] = useState(window.innerWidth < 601 ? '#2C3142' : 'white');
    const fallbackLetter = ((userData?.User_Information?.User_FirstName?.charAt(0) || '') + (userData?.User_Information?.User_LastName?.charAt(0) || '')).toUpperCase();

    useEffect(() => {
        const handleResize = () => {
            const isMobileView = window.innerWidth <= 600;
            setIsMobile(isMobileView);
            setBgColor(isMobileView ? '#2C3142' : 'white');
        };
    
        window.addEventListener('resize', handleResize);
        handleResize();
    
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const currentFollowFlag = followStatusMap[userData?.User_Information?.User_ID] ?? followData?.followFlag;

    useEffect(() => {
        const handleIntersection = (entries) => {
            entries.forEach((entry) => {
                const video = entry.target;
                if (entry.intersectionRatio >= 0.75) {
                    video.play().catch(() => {});
                    // video.muted = false;
                } else {
                    video.pause();
                    // video.muted = true;
                }
            });
        };
    
        if (window.innerWidth < 801) {
            observer.current = new IntersectionObserver(handleIntersection, {
                threshold: [0.75]
            });
    
            videoRefs.current.forEach((video) => {
                if (video) observer.current.observe(video);
            });
        }
    
        return () => {
            if (observer.current) {
                observer.current.disconnect();
            }
        };
    }, [contentType, userPosts, savePost]);

    return (
        <div className='profile-dashboard'>

            <Helmet>
                <title>{SEO.PROFILE_PAGE.TITLE}</title>
                <meta name="description" content={SEO.PROFILE_PAGE.DESCRIPTION} />
                <meta name="keywords" content={SEO.PROFILE_PAGE.KEYWORDS} />
                <meta name="robots" content="index, follow" />
                <link rel="canonical" href={SEO.PROFILE_PAGE.CANONICAL} />
            
                <meta property="og:title" content={SEO.PROFILE_PAGE.TITLE} />
                <meta property="og:description" content={SEO.PROFILE_PAGE.DESCRIPTION} />
                <meta property="og:type" content={SEO.PROFILE_PAGE.OG.TYPE} />
                <meta property="og:url" content={SEO.PROFILE_PAGE.OG.URL} />
                <meta property="og:site_name" content={SEO.PROFILE_PAGE.OG.SITE_NAME} />
                <meta property="og:image" content='https://omyfood.io/OMF_logo_bg.png' />
            
                <meta name="twitter:image" content='https://omyfood.io/OMF_logo_bg.png' />
                <meta name="twitter:title" content={SEO.PROFILE_PAGE.TWITTER.TITLE} />
                <meta name="twitter:description" content={SEO.PROFILE_PAGE.TWITTER.DESCRIPTION} />
                <meta
                    name="twitter:card"
                    content='summary_large_image'
                />
            
                <script type="application/ld+json">
                    {JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'WebPage',
                        'name': `User Profile | ${CONSTANT.OMYFOOD}`,
                        'description': 'Access and manage your OMF user profile. Update personal info, preferences, and account settings.',
                        'url': `${CONSTANT.OMYFOOD_WEB_LINK}/profile`,
                        'breadcrumb': {
                            '@type': 'BreadcrumbList',
                            'itemListElement': [
                                {
                                    '@type': 'ListItem',
                                    'position': 1,
                                    'name': 'Home',
                                    'item': `${CONSTANT.OMYFOOD_WEB_LINK}`
                                },
                                {
                                    '@type': 'ListItem',
                                    'position': 2,
                                    'name': 'Profile',
                                    'item': `${CONSTANT.OMYFOOD_WEB_LINK}/profile`
                                }
                            ]
                        },
                        'mainEntity': {
                            '@type': 'Person',
                            'name': 'OMF User',
                            'description': 'Registered customer of OMF food delivery platform',
                            'identifier': `${CONSTANT.OMYFOOD_WEB_LINK}/profile`
                        }
                    },)}
                </script>
            </Helmet>
            
            {isLoading && (
                <div>
                    <Loader/>
                </div>
            )}
            <div className='profile-side-bar'>
                <SideMenuBar></SideMenuBar>
            </div>
            <div className='profile-home'>
                <div className='profile-Topbar-cont'>
                    <TopMenuBar></TopMenuBar>
                </div>
                <div className='profile-page-cont'>
                    <div className='profile-page' ref={containerRef}>
                        <div className='profilepage-main-cont'>
                            <div className='Topofpage-Main-container'>
                                <div className='Top1-layout'>
                                    {isMobile && (
                                        <BackIcon onClick={() =>handleDashboardNavigate()} />
                                    )}
                                    <BackButton/>
                                    {!userName &&<div className='Edit-button-layout'>
                                        <EditProfileIcon onClick={() =>handleNavigate()}/>
                                    </div>}
                                </div>
                                <div className="profile-container-center">
                                    <div className='profile-container-2'>
                                        <div className='profile-status-layout'>
                                            {isLoading ? (
                                                <Skeleton variant="circular" className='profile-status-icon-skeleton'/>
                                            ) : (
                                                imageURL ? (
                                                    <img src={imageURL} alt="Profile" style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'contain', border: '2px solid rgb(225, 53, 53)',backgroundColor : imageURL ? bgColor : 'red' }} onError={(e) => {
                                                        e.target.src = logoIcon; 
                                                    }}/>
                                                ) : (
                                                    <span>{fallbackLetter}</span>
                                                )
                                            )}
                                            <img src={img3} alt='status-symbol' className='profile-status-icon' />
                                        </div>
                                        <div className='Top-right-layout'>
                                            <div className='profile-name-layout'>
                                                <div>
                                                    <div className='profile-name-text'>
                                                        {isLoading ? <Skeleton variant="text" width={120} /> :
                                                            `${userData?.User_Information?.User_FirstName || ''} ${userData?.User_Information?.User_LastName || ''}`
                                                        }
                                                    </div>
                                                    <div className='profile-description-layout'>
                                                        {isLoading ? <Skeleton variant="text" width={200} /> : '@' + userData?.User_Information?.User_Username}
                                                    </div>
                                                </div>
                                                {(currentLoginUserId !== userData?.User_Information?.User_ID) &&
                                                 <div className='follow-button-layout'>
                                                 
                                                     <button className="follow-button" onClick={() => handleFollow()}>
                                                         {currentFollowFlag === 'true' || currentFollowFlag === true ? 'Unfollow' : 'Follow'}
                                                     </button>
                                                 </div>
                                                }
                                            </div>
                                           
                                            <div className='profile-info-layout'>
                                                <div className="user-profile-follow-like-posts-heading">
                                                    <p className='user-profile-above-data'>
                                                        {isLoading ? <Skeleton variant="text" width={30} className='skeleton-profile-follow' /> : followData?.followCountValue || 0}
                                                    </p>
                                                    <p className='user-profile-below-text'>{t('profilescreen.followers-heading')}</p>
                                                </div>
                                                <div className="user-profile-follow-like-posts-heading">
                                                    <p className='user-profile-above-data'>
                                                        {isLoading ? <Skeleton variant="text" width={30} className='skeleton-profile-follow' /> : followData?.followingCountValue || 0}
                                                    </p>
                                                    <p className='user-profile-below-text'>{t('profilescreen.following-heading')}</p>
                                                </div>
                                                <div className="user-profile-follow-like-posts-heading">
                                                    <p className='user-profile-above-data'>
                                                        {isLoading ? <Skeleton variant="text" width={30} className='skeleton-profile-follow' /> : userData?.RecordCount || 0}
                                                    </p>
                                                    <p className='user-profile-below-text'>{t('profilescreen.posts-heading')}</p>
                                                </div>
                                                <div className="user-profile-follow-like-posts-heading">
                                                    <p className='user-profile-above-data'>
                                                        {isLoading ? <Skeleton variant="text" width={30} className='skeleton-profile-follow' /> : userData?.Total_Likes || 0}
                                                    </p>
                                                    <p className='user-profile-below-text'>{t('profilescreen.likes-heading')}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className='Buttons-layout'>
                                    <>
                                        <Button
                                            className={`Posts-button ${contentType === 'posts' ? 'activeBtn' : 'inactive'}`}
                                            style={{ borderRadius: '0', width: buttonWidth }}
                                            variant='contained'
                                            onClick={() => {
                                                handleContentTypeChange('posts');
                                                fetchUserPosts();
                                            }}
                                        >
                                            {t('profilescreen.posts-button')}
                                        </Button>
                                        {!userName &&
                                            <Button
                                                className={`saved-button ${contentType === 'saved' ? 'activeBtn' : 'inactive'}`}
                                                style={{ borderRadius: '0', width: buttonWidth }}
                                                variant='contained'
                                                onClick={() => {
                                                    handleContentTypeChange('saved');
                                                    handleSavePost();
                                                } }
                                            >
                                                {t('profilescreen.saved-button')}
                                            </Button>
                                        }
                                    </>
                                </div>
                            </div>
                            <div className='Bottompage-container' style={{marginTop:'12px'}}>
                                {contentType === 'posts' && (
                                    <div className='main-container profile-main-container'>
                                        <div className='video-container profile-video-container'>
                                            {userPosts?.length > 0 && (
                                                userPosts?.map((item,index) => {

                                                    const attachmentKeys = parseAvatarKey(item?.Attachment_Keys || '[]');
                                                    if (!Array.isArray(attachmentKeys)) return null;

                                                    return attachmentKeys?.map((url) => (
                                                        <>
                                                            <div
                                                                className={`profile-post ${
                                                                    Saved === item?.Post_ID ? 'selected' : ''
                                                                }`}
                                                                key={item?.Post_ID}
                                                                onClick={() => {
                                                                    handleSavedClick(userPosts);
                                                                    // handleOpenSavedModal();
                                                                }}
                                                            >
                                                                <VideoCard                               
                                                                    key={item?.Post_ID}
                                                                    id={item?.Post_ID}
                                                                    vendorID={item?.Post_Vendor_id}
                                                                    AccountID={item?.Post_Created_by}
                                                                    url={url}
                                                                    attachmentKeys={item?.Attachment_keys || []}
                                                                    profilePic={profileImagePreview || ''}
                                                                    firstName = {userData?.User_Information?.User_FirstName || ''}
                                                                    lastName = {userData?.User_Information?.User_LastName || ''}
                                                                    userName={item?.User_Username || ''}
                                                                    restaurantName={item?.Post_Vendor_Name || ''}
                                                                    starPic={item?.Restaurant_Info?.[0]?.Star_Image || ''}
                                                                    rating={item?.Vendor_Avg_Rating || 0}
                                                                    distance={item?.Distance || 0.0}
                                                                    description={item?.Post_Description}
                                                                    likes={item?.Post_Likes_count}
                                                                    shares={item?.Post_Shares_count}
                                                                    comments={item?.Post_Comments_count}
                                                                    setLike={() => {}}
                                                                    activeUnmutedId={activeUnmutedId}
                                                                    setActiveUnmutedId={setActiveUnmutedId}
                                                                    index={index}
                                                                    ismuted={false}
                                                                    setVideoRef={(ref) => handleVideoRef(ref, index)}
                                                                    handleGlobalMuteChange={() => handleGlobalMuteChange(index)}
                                                                    autoplay={index === 0}
                                                                    likeFlag={item?.Like_flag}
                                                                    saveFlag={item?.Saved_flag}
                                                                    followFlag={followData?.followFlag}
                                                                    filter={item?.Post_filter || ''}
                                                                    reelsId={item?.Post_ID}
                                                                    user_Rating_count={item?.Vendor_Review_User_Count}
                                                                    onEditPost={() => handleEditPost(item)}
                                                                    onDeletePost={() => handleDeleteClick(item)}
                                                                    vendorAddress={
                                                                        `${item?.Vendor_Address || ''}, ${item?.Vendor_City || ''}, ${item?.Vendor_State || ''}, ${item?.Vendor_Pincode || ''}, ${item?.Vendor_Country || ''}`
                                                                    }
                                                                />
                                                            </div>
                                                        </>
                                                    ));
                                                })
                                            )}
                                            {!isLoading && userPosts?.length === 0 && (
                                                <div className='no-reels-and-images-message'>
                                            No Posts Available.
                                                </div>
                                            )}

                                        </div>
                                    </div>
                                )}
                                {contentType === 'saved' &&
                                    <div className='main-container profile-main-container'>
                                        <div className='video-container profile-video-container'>
                                            {savePost?.length > 0 ? (
                                                savePost?.map((item,index) => {

                                                    const attachmentKeys = parseAvatarKey(item?.Attachment_Keys || '[]');
                                                    if (!Array.isArray(attachmentKeys)) return null;

                                                    return attachmentKeys?.map((url) => (
                                                        <>
                                                            <div
                                                                className={`profile-post ${
                                                                    Saved === item?.Post_ID ? 'selected' : ''
                                                                }`}
                                                                key={item?.Post_ID}
                                                                onClick={() => {
                                                                    handleSavedClick(userPosts);
                                                                    // handleOpenSavedModal();
                                                                }}
                                                            >
                                                                <VideoCard                               
                                                                    key={item?.Post_ID}
                                                                    id={item?.Post_ID}
                                                                    vendorID={item?.Post_Vendor_id}
                                                                    AccountID={item?.Post_Created_by}
                                                                    url={url}
                                                                    attachmentKeys={item?.Attachment_keys || []}
                                                                    profilePic={profileImagePreview || ''}
                                                                    firstName = {userData?.User_Information?.User_FirstName || ''}
                                                                    lastName = {userData?.User_Information?.User_LastName || ''}
                                                                    userName={item?.User_Username || ''}
                                                                    restaurantName={item?.Vendor_Name || ''}
                                                                    starPic={item?.Restaurant_Info?.[0]?.Star_Image || ''}
                                                                    rating={item?.Vendor_Avg_Rating || 0}
                                                                    distance={item?.Vendor_Distance_miles || 0.0}
                                                                    description={item?.Post_Description}
                                                                    likes={item?.Post_Likes_count}
                                                                    shares={item?.Post_Shares_count}
                                                                    comments={item?.Post_Comments_count}
                                                                    setLike={() => {}}
                                                                    activeUnmutedId={activeUnmutedId}
                                                                    setActiveUnmutedId={setActiveUnmutedId}
                                                                    index={index}
                                                                    ismuted={activeVideoIndex !== index}
                                                                    setVideoRef={(ref) => handleVideoRef(ref, index)}
                                                                    handleGlobalMuteChange={() => handleGlobalMuteChange(index)}
                                                                    autoplay={index === 0}
                                                                    likeFlag={item?.Like_flag}
                                                                    saveFlag={item?.Saved_flag}
                                                                    followFlag={item?.Follow_Flag}
                                                                    filter={item?.Post_filter || ''}
                                                                    reelsId={item?.Post_ID}
                                                                    user_Rating_count={item?.Vendor_Review_Count}
                                                                    onEditPost={() => handleEditPost(item)}
                                                                    onDeletePost={() => handleDeleteClick(item)}
                                                                    vendorAddress={
                                                                        `${item?.Vendor_Address || ''}, ${item?.Vendor_City || ''}, ${item?.Vendor_State || ''}, ${item?.Vendor_Pincode || ''}, ${item?.Vendor_Country || ''}`
                                                                    }
                                                                />
                                                            </div>
                                                        </>
                                                    ));
                                                })
                                            ) : (
                                                <div className='no-reels-and-images-message'>
                                            No Posts Available.
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <RightSideBar/>
                </div>
            </div>
            {openEditModal && selectedPost && (
                <CreatePost
                    openInitialPopup={openEditModal}
                    setOpenInitialPopup={setOpenEditModal}
                    isEditMode={true}
                    selectedFiles={selectedFiles}
                    setSelectedFiles={setSelectedFiles}
                    postId={selectedPost?.Post_ID}
                    handleCloseModal={() => setOpenEditModal(false)}
                />
            )}
            {showDeleteModal && (
                <DeleteOfferModal
                    open={showDeleteModal}
                    handleClose={cancelDelete}
                    confirmDelete={confirmDelete}
                    cancelDelete={cancelDelete}
                    message='Are you sure you want to delete this post?'
                />
            )}
        </div>
    );
};

export default Profilescreen;
